import { defineComponent as _defineComponent } from 'vue'
import CommonModal from './CommonModal.vue';
import CommonButton from '../CommonButton.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertModal',
  setup(__props, { expose: __expose }) {

const titleElem = ref<HTMLHeadElement>();
const contentElem = ref<HTMLParagraphElement>();
const buttons = ref<{
  text: string;
  action: () => void;
  cta?: 'cta' | 'error' | 'warning' | 'secondary';
  type?: 'filled' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
}[]>([]);
const icon = ref<string>();
const iconColor = ref<string>();

const alertModal = ref<InstanceType<typeof CommonModal>>();

__expose({
  open: (params: {
    title: string,
    content: string,
    buttons?: {
      text: string;
      action: () => void;
      cta?: 'cta' | 'error' | 'warning' | 'secondary';
      type?: 'filled' | 'outlined' | 'text';
      size?: 'small' | 'medium' | 'large';
    }[],
    icon?: string,
    iconColor?: string,
    zIndex?: number,
  }) => {
    titleElem.value!.innerText = params.title;
    contentElem.value!.innerText = params.content;
    buttons.value = params.buttons ?? [
      {
        text: 'Ok',
        action: () => {
          alertModal.value?.close();
        },
      },
    ];
    icon.value = params.icon ?? 'exclamation-circle';
    iconColor.value = params.iconColor || 'var(--token-semantic-color-fg-default)';
    
    alertModal.value?.open({ zIndex: params.zIndex ?? 3 });
  },
  close: () => {
    alertModal.value?.close();
  },
});

const __returned__ = { titleElem, contentElem, buttons, icon, iconColor, alertModal, CommonModal, CommonButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})